const requestedImportIds = new Set<string>();

// 取込 API を送信済みの import を記録し、同じ import への再送を防ぐ。
// useRef ではコンポーネントの再マウントでフラグごと作り直されて再送を防げないため、
// モジュールスコープで保持する
export const markImportRequested = (importId: string): boolean => {
  if (requestedImportIds.has(importId)) return false;

  requestedImportIds.add(importId);

  return true;
};

// 送信に失敗した import は取り込まれていないため、記録を取り消して再送できるようにする
export const releaseImportRequest = (importId: string): void => {
  requestedImportIds.delete(importId);
};
